import { useCreateEncounter } from "@elation/api-client/src/stitch-web";
import {
  registerEncounterId,
  useEncounterId,
  useIsEncounterCompleted,
  useIsEncounterFinalizing,
} from "@src/features/encounters/state/encounterActor";
import { navigation } from "@src/navigation";
import { TodayPage } from "@src/pages/PatientDetail/pages/TodayPage";
import { useEffect } from "react";
import { Navigate } from "react-router-dom";
import { usePatientLayoutContext } from "../layouts/patient";

export function meta() {
  return [
    { title: "Today" },
    { name: "description", content: "Patient today agenda and notes" },
  ];
}

export default function PatientTodayRoute() {
  const { patientId, isFallbackPolling = false } = usePatientLayoutContext();

  const encounterId = useEncounterId();
  const isEncounterFinalizing = useIsEncounterFinalizing();
  const isEncounterCompleted = useIsEncounterCompleted();

  const {
    mutate: createEncounter,
    data: encounterResult,
    reset,
  } = useCreateEncounter();

  useEffect(() => {
    if (!patientId) return;
    reset();
    createEncounter({ data: { patientId: Number(patientId) } });
  }, [patientId, createEncounter, reset]);

  const createdEncounterId = encounterResult?.data?.id;
  useEffect(() => {
    registerEncounterId(createdEncounterId);
    return () => registerEncounterId(undefined);
  }, [createdEncounterId]);

  if (
    (isEncounterFinalizing || isEncounterCompleted) &&
    patientId &&
    encounterId
  ) {
    return (
      <Navigate
        to={navigation.patientEncounter(patientId, encounterId.toString())}
      />
    );
  }

  return <TodayPage isFallbackPolling={isFallbackPolling} />;
}
